<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.users')" :title="$t('help.users_title')" />

    <filters
      class="white-container"
      :inputs="filters"
      @filter="filterUsers"
      :extend-button="true"
      :extended="extended"
      :filters="filterObject"
      :manual-apply="true"
      global-filter="users.global"
      :loading="loading"
    />

    <div class="position-relative">
      <loader v-if="loading" />

      <v-server-table
        ref="appTable"
        name="usersTable"
        class="white-container"
        url="/admin/users?order=Users.id"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true"
      >
        <template slot="beforeFilter" class="w-100">
          <div class="w-100 d-flex flex-row align-items-center flex-wrap">
            <div>
              <router-link to="/users/create">
                <b-button class="px-4">
                  {{ $t('users.add_new_user') }}
                </b-button>
              </router-link>
              <b-button variant="outline-primary" @click="exportOpen" class="ml-2">
                {{ $t('users.export') }}
              </b-button>
            </div>
          </div>
        </template>

        <template slot="id" slot-scope="props">
          <router-link
            :to="{ path: `/users/edit/${props.row.id}`, params: props.row }"
            target="_blank"
          >
            {{ props.row.id }}
          </router-link>
        </template>
        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{ $t('global.showing') }}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{ $t('global.of_records_found', { number: totalRecordsCount }) }}
        </template>
        <template slot="full_name" slot-scope="props">
          <span class="text-capitaliloadingze">
            {{ props.row.first_name }} {{ props.row.last_name }}
          </span>
        </template>
        <template slot="location" slot-scope="props">
          <column-location :row="props.row" />
        </template>
        <template slot="company" slot-scope="props">
          <div>
            {{ props.row.company || $t('global.not_set') }}
          </div>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L" />
        </template>
        <template slot="subscriptions" slot-scope="props">
          <column-subscriptions :row="props.row" column="subscriptions" />
        </template>
        <template slot="renewal_date" slot-scope="props" v-if="props.row.subscriptions.length">
          <div v-for="(subscription, index) in props.row.subscriptions" :key="index">
            {{ subscription.autorenew ? formatDate(subscription.subscription_end_date, 'L') : '' }}
          </div>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
            :show-delete-button="false"
            :route="{ path: `/users/edit/${props.row.id}`, params: props.row }"
          />
        </template>
      </v-server-table>
    </div>

    <exportSection 
      ref="export"
      @hide="exportExpanded(false)"
      @show="exportExpanded(true)"
      :opened="isExportExpanded"
      :filters="params"
    />
  </div>
</template>

<script>
import axios from '@/utils/axios';
import { Event } from 'vue-tables-2';
import usersFilters from './usersFilters.js';
import filters from '@/components/global/filtersUsers';
import i18n from '@/utils/i18n';
import { assign } from 'lodash';
import exportSection from '@/components/global/exportSection';

export default {
  middleware: 'auth',
  name: 'Users',
  components: {
    exportSection,
    filters,
  },
  data: () => {
    return {
      loading: false,
      totalRecordsCount: null,
      targetEmail: null,
      params: {},
      columns: [
        'id',
        'full_name',
        'email',
        'company',
        'created_at',
        'subscriptions',
        'renewal_date',
        'actions',
      ],
      filters: usersFilters,
      filterObject: {},
      extended: false,
      usersFiltered: false,
      options: {
        skin: [],
        headings: {
          id: '#',
          full_name: i18n.t('users.full_name'),
          email: i18n.t('users.email'),
          location: i18n.t('users.location'),
          created_at: i18n.t('form.created_at'),
          subscriptions: i18n.t('users.subscription_info'),
          renewal_date: i18n.t('form.renewal_date'),
          actions: i18n.t('global.actions'),
        },
        dateColumns: ['created_at'],
        sortable: [],
        clientMultiSorting: false,
        customFilters: ['custom'],
        perPageValues: [10, 25],
        perPage: localStorage.getItem('perPage') && [10, 25].includes(Number(localStorage.getItem('perPage')))
            ? Number(localStorage.getItem('perPage'))
            : 10,
        filterable: false,
        requestFunction: function (data) {
          let params = {};
          params.limit = data.limit;
          params.filter = data.custom;
          params.page = data.page;

          localStorage.setItem('perPage', data.limit);
          if (!params.filter) {
            params.filter = {};
          }
          // if (params.filter['userresourcerelationships.suspended'] === undefined) {
          //   params.filter['userresourcerelationships.suspended'] = false
          // }
          return axios
            .get(this.url, {
              params: params,
            })
            .catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);
          return {
            data: data.data.items,
            count: data.data.paginator.total_items,
          };
        },
      },
      isExportExpanded: false,
    };
  },
  mounted() {
    Event.$on('vue-tables.usersTable.loaded', ({ data }) => {
      this.totalRecordsCount = data.paginator.total_items;
      if (!this.usersFiltered && !_.isEmpty(this.$route.query)) {
        this.checkUrlParams();
      }
    });
  },
  methods: {
    exportExpanded(value){
      this.isExportExpanded = value;
    },
    exportOpen() {
      this.isExportExpanded = true;
      setTimeout(() => {
        this.$refs.export.$el.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    },
    checkUrlParams() {
      this.fransformFilters(this.$route.query);
      this.extended = true;
    },
    fransformFilters(params) {
      this.filterUsers(params);
      _.mapKeys(params, (value, key) => {
        if (value === 'true') {
          params[key] = true;
        } else if (value === 'false') {
          params[key] = false;
        } else {
          params[key] = value;
        }
      });
      this.createFilters(assign({}, params));
    },
    filterUsers(params) {
      // _.mapKeys(this.params, (value, field) => {
      //   if (!params.hasOwnProperty(field)) {
      //     delete this.params[field]
      //   } else {
      //     console.log(field);
      //     this.params[field] = params[field]
      //   }
      // });
      // Object.assign(this.params, params);
      this.params = params;
      // this.$router.push({path: this.$route.path, query: params});
      Event.$emit('vue-tables.usersTable.filter::custom', params);
      this.usersFiltered = true;
    },
    createFilters(params) {
      this.filterObject = params;
      if (params['userplanrelationships.subscription_start_date']) {
        this.filterObject['userplanrelationships.subscription_start_date'] = {
          start: new Date(params['userplanrelationships.subscription_start_date'].split('-')[0]),
          end: new Date(params['userplanrelationships.subscription_start_date'].split('-')[1]),
        };
      }
      if (params['userplanrelationships.subscription_end_date']) {
        this.filterObject['userplanrelationships.subscription_end_date'] = {
          start: new Date(params['userplanrelationships.subscription_end_date'].split('-')[0]),
          end: new Date(params['userplanrelationships.subscription_end_date'].split('-')[1]),
        };
      }
      if (params['userplanrelationships.autorenew']) {
        this.filterObject['userplanrelationships.autorenew'] = this.formatOption(
          params['userplanrelationships.autorenew'],
          'label',
        );
      }
      if (params.paid_subscriptions) {
        if (params.paid_subscriptions === true) {
          this.filterObject.paid_subscriptions = {
            value: true,
            label: this.$t('paid_status.paid'),
          };
        }
        if (params.paid_subscriptions === false) {
          this.filterObject.paid_subscriptions = {
            value: false,
            label: this.$t('paid_status.free'),
          };
        }
      }
      if (params['teams.count']) {
        if (params['teams.count'] === '-1')
          this.filterObject['teams.count'] = {
            value: -1,
            label: this.$t('form.any_group'),
          };
        if (params['teams.count'] === '0')
          this.filterObject['teams.count'] = {
            value: 0,
            label: this.$t('form.without_group'),
          };
      }
      if (params['userresourcerelationships.suspended']) {
        this.filterObject['userresourcerelationships.suspended'] = {
          value: false,
          label: this.$t(`user_status.true`),
        };
      }
      if (params['userplanrelationships.is_trial']) {
        this.filterObject['userplanrelationships.is_trial'] = {
          value: true,
          label: this.$t(`is_trial.true`),
        };
      }
      if (params['userplanhistory.is_trial']) {
        this.filterObject['userplanhistory.is_trial'] = {
          value: true,
          label: this.$t(`is_trial.true`),
        };
      }
      this.$forceUpdate();
    },
    exportSearchedUsers() {
      this.loading = true;

      this.exportList({ filter: this.params, download: true }, 'users').finally(
        () => (this.loading = false),
      );
    },
  },
  destroyed() {
    Event.$off('vue-tables.usersTable.loaded');
  },
};
</script>
